// extracted by mini-css-extract-plugin
export default {"root":"companyDividendsInfo_root__rne3U","field":"companyDividendsInfo_field__bxmLk"};